import Tutustuminen from "../components/Tutustuminen";

function TutustuPage(){
    return <div>
        <Tutustuminen/>
    </div>
}

export default TutustuPage;